import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

function DialogAvenida(props) {
  return (
    <div className="boletosDialog">
      <Dialog
        visible
        className="boletosDialog"
        onHide={() => props.sair()}
        style={{
          minHeigth: "30vw",
          minWidth: "20vw",
          textAlign: "center",
          //borderRadius: '30px',
          //padding: '10px'
        }}
        draggable={false}
        header="Impossível realizar negociação no momento"
      >
        <div>
          <div>
            <h5>Suas débitos cadastradas na plataforma estão indisponíveis para negociação</h5>
          </div>
          <div className="mt-5">
            <Button label="Retornar à página inicial" icon="pi pi-arrow-left" onClick={() => props.sair()} />
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default DialogAvenida;
